export default "__VITE_ASSET__CrKwF$FZ__"